module.exports = __webpack_public_path__ + "static/home-green-046c2f5101ce11fb5833f1ddc36a1e99.png";